import { useResult } from "2g-grid";

import { DATA } from "b2b/api/paths";
import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";

export default function useUzivateleGrid({ ico }) {
  const { title } = useMessages();
  const columns = useColumns();

  return useResult({
    moduleKey: "uzivateleGrid",
    title: title(),
    url: DATA.uzivatele(ico),
    method: "get",
    collapsed: true,
    columns,
    showFilterDescription: false,
    selectable: false,
    sortable: true,
    loadOnInit: true
  });
}
